import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const respiratory: AnswerPathTreeNode = {
  path: 'respiratory',
  children: [
    { path: 'healthOtherRespiratoryDetails', nodeId: NodeIds.healthOtherRespiratoryDetails },
    { path: 'healthOtherRespiratoryChoices', nodeId: NodeIds.healthOtherRespiratoryChoices },
  ],
};
